import { newRequest } from '../../../config';

let onSessionExpired = null;

const parseResponse = async (response) => {
    const text = await response.text();

    try {
        const parsedResponse = JSON.parse(text);

        if (Number(parsedResponse?.status?.statusCode) === 200) {
            if (onSessionExpired) {
                onSessionExpired();
            }
        }

        return parsedResponse;
    } catch (error) {
        return null;
    }
};

export const configureEsimApi = (sessionExpiredHandler) => {
    onSessionExpired = sessionExpiredHandler;
};

const fetchJson = async (url, body, method = 'GET') => {
    const response = await fetch(newRequest(url, body, method));
    return parseResponse(response);
};

export const esimApi = {
    getDestinations: (type) => {
        const query = type ? `?type=${encodeURIComponent(type)}` : '';
        return fetchJson(`esim/api/esim/catalog/destinations${query}`, null, 'GET');
    },
    getDestinationPlans: (code) => fetchJson(`esim/api/esim/catalog/destinations/${encodeURIComponent(code)}/plans`, null, 'GET'),
    getPlan: (planId) => fetchJson(`esim/api/esim/catalog/plans/${encodeURIComponent(planId)}`, null, 'GET'),
    getTerms: () => fetchJson('esim/api/esim/terms', null, 'GET'),
    getTermsStatus: () => fetchJson('esim/api/esim/terms/status', null, 'GET'),
    acceptTerms: (body) => fetchJson('esim/api/esim/terms/accept', body, 'POST'),
    validatePromo: (body) => fetchJson('esim/api/esim/promo-codes/validate', body, 'POST'),
    getOrderQuote: (body) => fetchJson('esim/api/esim/orders/quote', body, 'POST'),
    createOrder: (body) => fetchJson('esim/api/esim/orders', body, 'POST'),
    getOrder: (orderRef) => fetchJson(`esim/api/esim/orders/${encodeURIComponent(orderRef)}`, null, 'GET'),
    getOrders: (query = '') => fetchJson(`esim/api/esim/orders${query}`, null, 'GET'),
    paymentSuccess: (body) => fetchJson('esim/api/esim/orders/payment-success', body, 'POST'),
    getEsims: (query = '') => fetchJson(`esim/api/esim/esims${query}`, null, 'GET'),
    getEsim: (esimId) => fetchJson(`esim/api/esim/esims/${encodeURIComponent(esimId)}`, null, 'GET'),
    getEsimUsage: (esimId) => fetchJson(`esim/api/esim/esims/${encodeURIComponent(esimId)}/usage`, null, 'GET'),
    refreshEsimUsage: (esimId) => fetchJson(`esim/api/esim/esims/${encodeURIComponent(esimId)}/usage/refresh`, null, 'POST'),
    getTopupPlans: (esimId) => fetchJson(`esim/api/esim/esims/${encodeURIComponent(esimId)}/topup-plans`, null, 'GET'),
    getInstructions: (esimId) => fetchJson(`esim/api/esim/esims/${encodeURIComponent(esimId)}/instructions`, null, 'GET'),
    topupEsim: (esimId, body) => fetchJson(`esim/api/esim/esims/${encodeURIComponent(esimId)}/topup`, body, 'POST'),
    getMonthlyLimit: () => fetchJson('esim/api/esim/limits/monthly', null, 'GET'),
    getBalance: () => fetchJson('esim/api/esim/balance', null, 'GET')
};
